// @flow @jsx h

import { bem } from '@nrk/dh-utils'
import { Paragraph } from '@nrk/dh-feature-components'
import { h } from 'preact'
import style from '../index.css'

import type { DefaultSlideProps } from '../types'

function DefaultCard (props: DefaultSlideProps) {
  const { viewport } = props
  const { align, content, credit } = props.value

  const wrapperInlineStyle = {}

  if (viewport.height > -1) {
    wrapperInlineStyle.marginTop = `${viewport.height - 10}px`
  }

  return (
    <div className={bem(style.defaultCard, align)}>
      <div className={style.defaultCard__wrapper} style={wrapperInlineStyle}>
        {content &&
          content.map((item, itemIdx) => (
            <Paragraph html={item.value} key={String(itemIdx)} />
          ))}
        {credit && <div className={style.defaultCard__credit}>{credit}</div>}
      </div>
    </div>
  )
}

export default DefaultCard



// WEBPACK FOOTER //
// ./src/v1/components/VisualStory/cards/DefaultCard.js